import React from 'react';
import cn from 'classnames';
import { useAtomValue } from 'jotai';

import { AlfaBankSignBoxMColorIcon } from '@alfalab/icons-logo/AlfaBankSignBoxMColorIcon';

import { platformAtom } from '../../atoms/platform/atom';

import styles from './index.module.css';

type Props = {
    headerBg?: boolean;
};

export const Header = ({ headerBg }: Props) => {
    const platform = useAtomValue(platformAtom);

    return (
        <header className={cn(styles.header, styles[platform], { [styles.headerBg]: headerBg })}>
            <AlfaBankSignBoxMColorIcon className={cn(styles.logo, styles[platform])} />
        </header>
    );
};
